import { Request as request } from "@/utils/request";

// /api/crypto-pay/create-invoice
/**
 * 创建 invoice
 * @param {object} params
 * @param {string} params.token 支付token
 * @param {string} params.chain 支付链
 * @returns
 */
let createInvoice = (params) => {
  return request("/api/crypto-pay/new-create-invoice", {
    method: "POST",
    params,
  });
};

export { createInvoice };
